
/**
 * @class Blog
 * @classdesc The blog class handles the blog page functionality
 * @extends Core.SectionComponent
 */
export default class Blog extends Core.SectionComponent {
  constructor(el, context) {
    super(el, context);

    this.blogTagsSelect = el.querySelector('[data-blog-tags]');

    this._filterBlog = this._filterBlog.bind(this);

    if (this.blogTagsSelect) {
      this.events.register(this.blogTagsSelect, 'change', this._filterBlog);
    }
  }

  /**
   * Updates the current view according to the selected blog tag
   *
   * @param {Event} e - A <select> 'change' event object
   * @private
   */
  _filterBlog(e) {
    const {
      target: {
        dataset: {
          blogUrl,
        },
      },
    } = e;

    window.location.href = this.blogTagsSelect.value === 'all' || this.blogTagsSelect.value === ''
      ? blogUrl
      : `${blogUrl}/tagged/${this.blogTagsSelect.value}`;
  }
}
